module.exports = __webpack_public_path__ + "img/d-6.4c6636bf.png";